module.exports = __webpack_public_path__ + "img/我.70323606.jpg";